import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import { photoUrl } from 'mk/photo/photoUrl';
import { PhotoEntity } from 'mk2/schemas';
import React from 'react';
import styles from './CoverBreadcrumbs.mscss';

interface OwnProps {
    className?: string;
    photo?: PhotoEntity;
    height?: number;
}

type Props = OwnProps;

class CoverBreadcrumbs extends React.Component<Props> {
    public render() {
        const {className, photo, height, children} = this.props;

        return (
            <div className={cx(styles.CoverBreadcrumbs, className)}>
                {photo &&
                <div
                    className={cx(
                        styles.CoverBreadcrumbs__photo,
                        styles['CoverBreadcrumbs__photo--trimY'],
                    )}
                    style={{
                        backgroundImage: `url('${photoUrl(photo, 's1600x1600')}')`,
                    }}
                />
                }
                <div className={styles.CoverBreadcrumbs__breadcrumbs}>
                    {React.Children.toArray(children).filter((child) => !!child).map((child, index) => (
                        <React.Fragment key={index}>
                            {index > 0 && (
                                <span className={styles.CoverBreadcrumbs__breadcrumbs__separator}>
                                    <FontAwesomeIcon icon={faAngleRight} />
                                </span>
                            )}
                            {React.isValidElement<{ className?: string }>(child)
                                ? React.cloneElement(child, {className: cx(child.props.className, styles.CoverBreadcrumbs__breadcrumbs__item)})
                                : (
                                    <span className={styles.CoverBreadcrumbs__breadcrumbs__item}>{child}</span>
                                )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        );
    }

}

export default CoverBreadcrumbs;
